/**
 * Action types for customer aggregate stats graph functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle connected clients graph.
 */

export const CUST_AGGR_STATS_GRAPH_API_LOADING =
	'CUST_AGGR_STATS_GRAPH_API_LOADING';
export const SAVE_CUST_AGGR_STATS_GRAPH = 'SAVE_CUST_AGGR_STATS_GRAPH';
export const GRAPH_BY_FILTER = 'GRAPH_BY_FILTER';
export const GRAPH_BY_FILTER_CUSTOM = 'GRAPH_BY_FILTER_CUSTOM';

/**
 * Action types for site aggregate stats graph functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle connected clients graph.
 */

export const SITE_AGGR_STATS_GRAPH_API_LOADING =
	'SITE_AGGR_STATS_GRAPH_API_LOADING';
export const SAVE_SITE_AGGR_STATS_GRAPH = 'SAVE_SITE_AGGR_STATS_GRAPH';

// site dashboard ssid load graph constant  
export const SITE_DASHBOARD_SSID_LOAD_GRAPH_REQUEST = 'SITE_DASHBOARD_SSID_LOAD_GRAPH_REQUEST';
export const SITE_DASHBOARD_SSID_LOAD_GRAPH_SUCCESS = 'SITE_DASHBOARD_SSID_LOAD_GRAPH_SUCCESS';
export const SITE_DASHBOARD_SSID_LOAD_GRAPH_FAIL = 'SITE_DASHBOARD_SSID_LOAD_GRAPH_FAIL';

// site dashboard ap usage graph constants
export const SITE_AP_MAX_MIN_USAGE_GRAPH_LOADING = 'SITE_AP_MAX_MIN_USAGE_GRAPH_LOADING';
export const SAVE_SITE_AP_MAX_MIN_USAGE_GRAPH_DATA = 'SAVE_SITE_AP_MAX_MIN_USAGE_GRAPH_DATA';
export const CLEAR_SITE_AP_USAGE_GRAPH = 'CLEAR_SITE_AP_USAGE_GRAPH';

// site dashboard ap clients graph constants
export const SITE_AP_MAX_MIN_CLIENTS_GRAPH_LOADING = 'SITE_AP_MAX_MIN_CLIENTS_GRAPH_LOADING';
export const SAVE_SITE_AP_MAX_MIN_CLIENTS_GRAPH = 'SAVE_SITE_AP_MAX_MIN_CLIENTS_GRAPH';
export const CLEAR_SITE_AP_CLIENTS_GRAPH = 'CLEAR_SITE_AP_CLIENTS_GRAPH';